import React from 'react';
import { ShieldCheck, MapPin } from 'lucide-react';

/**
 * Компонент с параметрами государственной поддержки
 */
const StateSupportsSection = ({ 
  formData, 
  handleInputChange, 
  errors 
}) => {
  const showStateSupports = formData.includeMaternityCapital || formData.includeRegionalPrograms;

  return (
    <div className="mb-6 bg-blue-50 dark:bg-blue-900/20 p-4 rounded-lg border border-blue-200 dark:border-blue-800">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <ShieldCheck className="w-5 h-5 mr-2 text-blue-500" />
        Государственная поддержка
      </h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Материнский капитал */}
        <div className="col-span-full">
          <label className="inline-flex items-center">
            <input
              type="checkbox"
              name="includeMaternityCapital"
              checked={formData.includeMaternityCapital}
              onChange={handleInputChange}
              className="form-checkbox"
            />
            <span className="ml-2 text-sm text-gray-700 dark:text-gray-300">
              Учитывать материнский (семейный) капитал
            </span>
          </label>
        </div>

        {/* Региональные программы */}
        <div className="col-span-full">
          <label className="inline-flex items-center">
            <input
              type="checkbox"
              name="includeRegionalPrograms"
              checked={formData.includeRegionalPrograms}
              onChange={handleInputChange}
              className="form-checkbox"
            />
            <span className="ml-2 text-sm text-gray-700 dark:text-gray-300">
              Учитывать региональные программы поддержки образования
            </span>
          </label>
        </div>

        {/* Параметры материнского капитала */}
        {formData.includeMaternityCapital && (
          <div>
            <label htmlFor="maternityCapitalAmount" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
              Сумма материнского капитала (руб.)
            </label>
            <input
              type="text"
              id="maternityCapitalAmount"
              name="maternityCapitalAmount"
              value={formData.maternityCapitalAmount}
              onChange={handleInputChange}
              className={`form-input w-full ${errors.maternityCapitalAmount ? 'input-error' : ''}`}
              placeholder="Например, 524 500"
            />
            {errors.maternityCapitalAmount && (
              <p className="mt-1 text-xs text-red-500 dark:text-red-400">
                {errors.maternityCapitalAmount}
              </p>
            )}
            <p className="mt-1 text-xs text-gray-600 dark:text-gray-400">
              Размер материнского капитала в 2023 г.: на первого ребенка - 524 500 руб., на второго - 168 600 руб. (если не получали на первого), всего - 693 100 руб.
            </p>
          </div>
        )}

        {/* Параметры региональных программ */}
        {formData.includeRegionalPrograms && (
          <div>
            <label htmlFor="regionalSupportAmount" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
              <MapPin className="w-4 h-4 mr-2 text-blue-500" />
              Размер региональной поддержки (руб.)
            </label>
            <input
              type="text"
              id="regionalSupportAmount"
              name="regionalSupportAmount"
              value={formData.regionalSupportAmount}
              onChange={handleInputChange}
              className={`form-input w-full ${errors.regionalSupportAmount ? 'input-error' : ''}`}
              placeholder="Например, 100 000"
            />
            {errors.regionalSupportAmount && (
              <p className="mt-1 text-xs text-red-500 dark:text-red-400">
                {errors.regionalSupportAmount}
              </p>
            )}
          </div>
        )}
      </div>
      
      {showStateSupports && (
        <div className="mt-4 bg-blue-100 dark:bg-blue-900/30 p-3 rounded-lg border border-blue-200 dark:border-blue-800">
          <div className="flex items-start">
            <ShieldCheck className="w-5 h-5 text-blue-600 dark:text-blue-400 mr-3 mt-1" />
            <div>
              <h4 className="text-sm font-medium text-blue-700 dark:text-blue-300 mb-1">
                О программах поддержки образования
              </h4>
              <p className="text-xs text-blue-600 dark:text-blue-400">
                {formData.includeMaternityCapital && (
                  <>
                    Материнский капитал можно использовать для оплаты образования детей в любом возрасте до 25 лет. 
                    Средства можно направить на оплату обучения и проживания в общежитии.
                    {formData.includeRegionalPrograms && <br />}
                  </>
                )}
                {formData.includeRegionalPrograms && (
                  <>
                    Многие регионы России предлагают дополнительные субсидии и программы поддержки образования. 
                    Узнайте о возможностях, доступных в вашем регионе, на сайте местной администрации или портале госуслуг.
                  </>
                )}
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default StateSupportsSection;